import React, { useEffect, useState } from "react";
import { Modal, Row, Col, Form, Button } from "react-bootstrap";
import DatePicker from "react-datepicker";
import { FiCalendar } from "react-icons/fi";
import "react-datepicker/dist/react-datepicker.css";

export default function EditTrainingModal({ show, onHide, editData }) {
  const [form, setForm] = useState({
    title: "",
    trainer: "",
    employees: "",
    cost: "",
    status: "Active",
    desc: "",
  });

  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);

  // PREFILL DATA
  useEffect(() => {
    if (editData) {
      setForm({
        title: editData.title || "",
        trainer: editData.trainer || "",
        employees: editData.employees || "",
        cost: editData.cost || "",
        status: editData.status || "Active",
        desc: editData.desc || "",
      });

      setStartDate(editData.startDate ? new Date(editData.startDate) : null);
      setEndDate(editData.endDate ? new Date(editData.endDate) : null);
    }
  }, [editData]);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleUpdate = () => {
    console.log("Updated Data:", { ...form, startDate, endDate });
    onHide();
  };

  return (
    <Modal show={show} onHide={onHide} centered size="lg" className="training-modal">
      <Modal.Header closeButton>
        <Modal.Title>Edit Training</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Form>
          <Row className="g-3">
            <Col md={6}>
              <Form.Group>
                <Form.Label>Training Type</Form.Label>
                <Form.Control
                  name="title"
                  value={form.title}
                  onChange={handleChange}
                />
              </Form.Group>
            </Col>

            <Col md={6}>
              <Form.Group>
                <Form.Label>Trainer</Form.Label>
                <Form.Control
                  name="trainer"
                  value={form.trainer}
                  onChange={handleChange}
                />
              </Form.Group>
            </Col>

            <Col md={6}>
              <Form.Group>
                <Form.Label>Employees</Form.Label>
                <Form.Control
                  name="employees"
                  value={form.employees}
                  onChange={handleChange}
                />
              </Form.Group>
            </Col>

            <Col md={6}>
              <Form.Group>
                <Form.Label>Training Cost</Form.Label>
                <Form.Control
                  name="cost"
                  value={form.cost}
                  onChange={handleChange}
                />
              </Form.Group>
            </Col>

            {/* START DATE */}
            <Col md={6}>
              <Form.Group>
                <Form.Label>Start Date</Form.Label>
                <div className="date-wrapper">
                  <DatePicker
                    selected={startDate}
                    onChange={(date) => setStartDate(date)}
                    className="form-control"
                    dateFormat="dd/MM/yyyy"
                    placeholderText="dd/mm/yyyy"
                  />
                  {/* <FiCalendar className="calendar-icon" /> */}
                </div>
              </Form.Group>
            </Col>

            {/* END DATE */}
            <Col md={6}>
              <Form.Group>
                <Form.Label>End Date</Form.Label>
                <div className="date-wrapper">
                  <DatePicker
                    selected={endDate}
                    onChange={(date) => setEndDate(date)}
                    className="form-control"
                    dateFormat="dd/MM/yyyy"
                    placeholderText="dd/mm/yyyy"
                  />
                  {/* <FiCalendar className="calendar-icon" /> */}
                </div>
              </Form.Group>
            </Col>

            <Col md={12}>
              <Form.Group>
                <Form.Label>Description</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={3}
                  name="desc"
                  value={form.desc}
                  onChange={handleChange}
                />
              </Form.Group>
            </Col>

            <Col md={12}>
              <Form.Group>
                <Form.Label>Status</Form.Label>
                <Form.Select
                  name="status"
                  value={form.status}
                  onChange={handleChange}
                >
                  <option>Active</option>
                  <option>Inactive</option>
                </Form.Select>
              </Form.Group>
            </Col>
          </Row>
        </Form>
      </Modal.Body>

      <Modal.Footer>
        <div className="footer-btns">
          <Button className="cancel-btn" onClick={onHide}>
            Cancel
          </Button>
          <Button className="submit-btn" onClick={handleUpdate}>
            Update
          </Button>
        </div>
      </Modal.Footer>

      {/* SAME CSS (REUSE EXACT DESIGN) */}
      <style>{`
        .training-modal .modal-content {
          border-radius: 10px;
          background: #f9fafb;
          border: none;
        }

        .training-modal .modal-header {
          border-bottom: 1px solid #e5e7eb;
          padding: 18px 20px;
        }

        .training-modal .modal-title {
          font-size: 20px;
          font-weight: 600;
        }

        .training-modal .modal-body {
          padding: 20px;
        }

        .training-modal .form-label {
          font-size: 14px;
          font-weight: 500;
          margin-bottom: 6px;
        }

        .training-modal .form-control,
        .training-modal .form-select {
          height: 44px;
          border-radius: 6px;
          border: 1px solid #e5e7eb;
        }

        .date-wrapper {
          position: relative;
        }

        .calendar-icon {
          position: absolute;
          right: 12px;
          top: 50%;
          transform: translateY(-50%);
          color: #6b7280;
        }

        .footer-btns {
          width: 100%;
          display: flex;
          justify-content: flex-end;
          gap: 10px;
        }

        .cancel-btn {
          background: #e5e7eb;
          border: none;
        }

        .submit-btn {
          background: #ff6b2c;
          border: none;
        }

        @media (max-width: 768px) {
          .footer-btns {
            flex-direction: column;
          }

          .footer-btns button {
            width: 100%;
          }
        }
      `}</style>
    </Modal>
  );
}